<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import OnboardingLayout from '../../../onboarding/components/OnboardingLayout.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'onboarding',
    }
})

// useOnboardingLoader()
</script>

<template>
  <OnboardingLayout />
</template>